import { Message } from 'semantic-ui-react';
import React from 'react';

import 'Styles/pages/vendorlinkintegration/preview.less';

const StudentBulkImportLoading = () => {
  return (
    <React.Fragment>
      <Message info>
        <Message.Header>{'The import has started'}</Message.Header>
        <Message.Content>
          {'You will receive a notification when it is finished. You can ' +
            'leave this page without interrupting the progress.'}
        </Message.Content>
      </Message>
      <div className={'animation-holder'}>
        <svg width="1026" height="473" viewBox="0 0 1026 473" fill="none">
          <g id="Frame 1">
            <g id="bus">
              <path
                id="Vector"
                d="M241.713 319.667H234.33C231.441 319.667 229.194 321.914 229.194 324.803V326.408H218.922V332.507H229.194V345.347C229.194 348.236 231.441 350.483 234.33 350.483H241.713C244.602 350.483 246.849 348.236 246.849 345.347V324.803C246.528 321.914 244.281 319.667 241.713 319.667Z"
                fill="#666666"
              />
              <path
                id="Vector_2"
                d="M218.28 317.741C217.638 313.889 214.428 311 210.576 311H16.0499C9.62985 311 4.17285 316.136 4.17285 322.877V438.437H172.056V443.252C172.056 448.067 175.908 451.919 180.402 451.919H258.405C263.22 451.919 266.751 448.067 266.751 443.252V390.608C266.751 386.756 264.504 383.546 260.973 382.583L235.293 377.126C232.725 376.163 230.799 374.237 230.478 371.348C228.873 357.866 220.206 329.618 218.28 317.741Z"
                fill="#F5E169"
              />
              <path
                id="Vector_3"
                d="M16.3711 420.782H4.17308C3.53108 420.782 3.21008 421.424 3.21008 422.066V432.338C3.21008 432.98 3.85208 433.622 4.49408 433.622H16.6921C19.5811 433.622 21.8281 431.375 21.8281 428.165V426.881C21.8281 423.35 19.2601 420.782 16.3711 420.782Z"
                fill="#E15B64"
              />
              <path
                id="Vector_4"
                d="M265.788 438.437H1.284C1.284 438.437 0 438.437 0 439.721C0 447.104 5.457 451.919 13.482 451.919H265.467C269.319 451.919 272.529 449.03 272.529 445.178C272.85 441.326 269.64 438.437 265.788 438.437Z"
                fill="#666666"
              />
              <g id="Group">
                <path
                  id="Vector_5"
                  d="M57.4589 467.648C69.6915 467.648 79.6079 457.732 79.6079 445.499C79.6079 433.266 69.6915 423.35 57.4589 423.35C45.2264 423.35 35.3099 433.266 35.3099 445.499C35.3099 457.732 45.2264 467.648 57.4589 467.648Z"
                  fill="white"
                />
                <path
                  id="Vector_6"
                  d="M57.4589 427.844C67.0889 427.844 75.1139 435.869 75.1139 445.499C75.1139 455.129 67.0889 463.154 57.4589 463.154C47.8289 463.154 39.8039 455.129 39.8039 445.499C39.8039 435.869 47.8289 427.844 57.4589 427.844ZM57.4589 418.856C42.6929 418.856 30.8159 430.733 30.8159 445.499C30.8159 460.265 42.6929 472.142 57.4589 472.142C72.2249 472.142 84.1019 460.265 84.1019 445.499C84.1019 430.733 72.2249 418.856 57.4589 418.856Z"
                  fill="#333333"
                />
              </g>
              <g id="Group_2">
                <path
                  id="Vector_7"
                  d="M57.459 457.376C64.0185 457.376 69.336 452.058 69.336 445.499C69.336 438.94 64.0185 433.622 57.459 433.622C50.8995 433.622 45.582 438.94 45.582 445.499C45.582 452.058 50.8995 457.376 57.459 457.376Z"
                  fill="#E6E6E6"
                />
              </g>
              <g id="Group_3">
                <path
                  id="Vector_8"
                  d="M216.996 467.648C229.229 467.648 239.145 457.732 239.145 445.499C239.145 433.266 229.229 423.35 216.996 423.35C204.763 423.35 194.847 433.266 194.847 445.499C194.847 457.732 204.763 467.648 216.996 467.648Z"
                  fill="white"
                />
                <path
                  id="Vector_9"
                  d="M216.996 427.844C226.626 427.844 234.651 435.869 234.651 445.499C234.651 455.129 226.626 463.154 216.996 463.154C207.366 463.154 199.341 455.129 199.341 445.499C199.341 435.869 207.366 427.844 216.996 427.844ZM216.996 418.856C202.23 418.856 190.353 430.733 190.353 445.499C190.353 460.265 202.23 472.142 216.996 472.142C231.762 472.142 243.639 460.265 243.639 445.499C243.639 430.733 231.762 418.856 216.996 418.856Z"
                  fill="#333333"
                />
              </g>
              <g id="Group_4">
                <path
                  id="Vector_10"
                  d="M216.996 457.376C223.555 457.376 228.873 452.058 228.873 445.499C228.873 438.94 223.555 433.622 216.996 433.622C210.437 433.622 205.119 438.94 205.119 445.499C205.119 452.058 210.437 457.376 216.996 457.376Z"
                  fill="#E6E6E6"
                />
              </g>
              <path
                id="Vector_11"
                d="M253.269 423.671H266.43C268.356 423.671 269.961 422.066 269.961 420.14V414.362C269.961 412.436 268.356 410.831 266.43 410.831H253.59C252.627 410.831 251.985 411.473 251.985 412.436V422.066C251.664 423.029 252.306 423.671 253.269 423.671Z"
                fill="#E0E0E0"
              />
              <path
                id="Vector_12"
                d="M210.897 324.803C209.613 321.593 207.687 319.667 205.119 319.667H187.785C184.254 319.667 181.365 324.161 181.365 329.618V365.891C181.365 369.743 184.254 372.632 188.106 372.632H212.181C216.354 372.632 219.564 369.101 218.922 364.928C216.354 347.915 210.897 324.803 210.897 324.803Z"
                fill="#333333"
              />
              <path
                id="Vector_13"
                d="M145.794 434H165.206C168.765 434 172 431.093 172 427.216V325.784C172 322.23 169.088 319 165.206 319H145.794C142.235 319 139 321.907 139 325.784V427.216C139.324 430.77 142.235 434 145.794 434Z"
                fill="#F47E60"
              />
              <path
                id="Vector_14"
                d="M102.72 372.632H124.869C127.758 372.632 130.005 370.385 130.005 367.496V324.803C130.005 321.914 127.758 319.667 124.869 319.667H102.72C99.831 319.667 97.584 321.914 97.584 324.803V367.496C97.584 370.385 99.831 372.632 102.72 372.632Z"
                fill="#333333"
              />
              <path
                id="Vector_15"
                d="M60.6691 372.632H82.8181C85.7071 372.632 87.9541 370.385 87.9541 367.496V324.803C87.9541 321.914 85.7071 319.667 82.8181 319.667H60.6691C57.7801 319.667 55.5331 321.914 55.5331 324.803V367.496C55.5331 370.385 57.7801 372.632 60.6691 372.632Z"
                fill="#333333"
              />
              <path
                id="Vector_16"
                d="M18.6179 372.632H40.7669C43.6559 372.632 45.9029 370.385 45.9029 367.496V324.803C45.9029 321.914 43.6559 319.667 40.7669 319.667H18.6179C15.7289 319.667 13.4819 321.914 13.4819 324.803V367.496C13.4819 370.385 16.0499 372.632 18.6179 372.632Z"
                fill="#333333"
              />
              <path
                id="Vector_17"
                d="M17.0131 388.04H127.116"
                stroke="#F8B26A"
                stroke-width="3.44832"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
            </g>
            <g id="school">
              <g id="Group_5">
                <path
                  id="Vector_18"
                  d="M1001.78 464H537.781V248H633.782L769.781 112L905.784 248H1001.78V464Z"
                  fill="#4B8BB1"
                />
              </g>
              <g id="Group_6">
                <path
                  id="Vector_19"
                  d="M817.781 368H721.781V464H817.781V368Z"
                  fill="#996459"
                />
              </g>
              <g id="Group_7">
                <path
                  id="Vector_20"
                  d="M815.781 336H723.781C722.676 336 721.781 336.895 721.781 338V368H817.781V338C817.781 336.895 816.886 336 815.781 336Z"
                  fill="#4BB9EC"
                />
              </g>
              <g id="Group_8">
                <path
                  id="Vector_21"
                  d="M843.617 48L856.656 28.438C858.289 25.985 858.445 22.829 857.054 20.227C855.663 17.625 852.953 16 850 16H770C765.578 16 762 19.578 762 24V72C762 76.422 765.578 80 770 80H850C852.953 80 855.664 78.375 857.055 75.773C858.446 73.171 858.289 70.015 856.657 67.562L843.617 48Z"
                  fill="#FF4F19"
                />
              </g>
              <g id="Group_9">
                <g id="Group_10">
                  <path
                    id="Vector_22"
                    d="M770 120C765.578 120 762 116.422 762 112V8C762 3.578 765.578 0 770 0C774.422 0 778 3.578 778 8V112C778 116.422 774.422 120 770 120Z"
                    fill="#5C546A"
                  />
                </g>
              </g>
              <g id="Group_11">
                <path
                  id="Vector_23"
                  d="M802.391 148.938C803.625 145.946 806.547 144 809.782 144H961.782C964.516 144 967.063 145.398 968.532 147.703L1024.53 235.703C1026.1 238.172 1026.2 241.289 1024.8 243.851C1023.39 246.406 1020.7 247.999 1017.78 247.999H897.782C895.657 247.999 893.626 247.155 892.126 245.655L804.126 157.655C801.836 155.367 801.148 151.93 802.391 148.938Z"
                  fill="#FF4F19"
                />
              </g>
              <g id="Group_12">
                <path
                  id="Vector_24"
                  d="M737.391 148.938C736.156 145.945 733.234 144 730 144H578C575.266 144 572.719 145.398 571.25 147.703L515.25 235.703C513.68 238.172 513.586 241.289 514.984 243.851C516.391 246.406 519.078 248 522 248H642C644.125 248 646.156 247.156 647.656 245.656L735.656 157.656C737.945 155.367 738.633 151.93 737.391 148.938Z"
                  fill="#FF4F19"
                />
              </g>
              <g id="Group_13">
                <g id="Group_14">
                  <path
                    id="Vector_25"
                    d="M905.891 255.891C903.844 255.891 901.797 255.11 900.235 253.547L770 123.313L639.766 253.547C636.641 256.672 631.578 256.672 628.453 253.547C625.328 250.422 625.328 245.359 628.453 242.234L764.344 106.343C767.469 103.218 772.532 103.218 775.657 106.343L911.548 242.234C914.673 245.359 914.673 250.422 911.548 253.547C909.984 255.109 907.938 255.891 905.891 255.891Z"
                    fill="#E44818"
                  />
                </g>
              </g>
              <g id="Group_15">
                <path
                  id="Vector_26"
                  d="M770.001 296C796.511 296 818.001 274.51 818.001 248C818.001 221.49 796.511 200 770.001 200C743.491 200 722.001 221.49 722.001 248C722.001 274.51 743.491 296 770.001 296Z"
                  fill="#FFEBB7"
                />
              </g>
              <g id="Group_16">
                <g id="Group_17">
                  <path
                    id="Vector_27"
                    d="M889.781 300C889.781 288.954 880.827 280 869.781 280C858.735 280 849.781 288.954 849.781 300C849.781 301.37 849.922 302.707 850.184 304H849.781V336H889.781V304H889.378C889.641 302.707 889.781 301.37 889.781 300Z"
                    fill="#4BB9EC"
                  />
                </g>
                <g id="Group_18">
                  <path
                    id="Vector_28"
                    d="M870 272C854.562 272 842 284.562 842 300V336C842 340.422 845.578 344 850 344H890C894.422 344 898 340.422 898 336V300C898 284.562 885.438 272 870 272ZM870 288C876.617 288 882 293.383 882 300V304H858V300C858 293.383 863.383 288 870 288ZM858 328V320H882V328H858Z"
                    fill="#524D4E"
                  />
                </g>
              </g>
              <g id="Group_19">
                <g id="Group_20">
                  <path
                    id="Vector_29"
                    d="M690.001 376H650.001V424H690.001V376Z"
                    fill="#4BB9EC"
                  />
                </g>
                <g id="Group_21">
                  <path
                    id="Vector_30"
                    d="M690 368H650C645.578 368 642 371.578 642 376V424C642 428.422 645.578 432 650 432H690C694.422 432 698 428.422 698 424V376C698 371.578 694.422 368 690 368ZM682 384V392H658V384H682ZM658 416V408H682V416H658Z"
                    fill="#524D4E"
                  />
                </g>
              </g>
              <g id="Group_22">
                <g id="Group_23">
                  <path
                    id="Vector_31"
                    d="M617.782 376H577.782V424H617.782V376Z"
                    fill="#4BB9EC"
                  />
                </g>
                <g id="Group_24">
                  <path
                    id="Vector_32"
                    d="M617.781 368H577.781C573.359 368 569.781 371.578 569.781 376V424C569.781 428.422 573.359 432 577.781 432H617.781C622.203 432 625.781 428.422 625.781 424V376C625.781 371.578 622.203 368 617.781 368ZM609.781 384V392H585.781V384H609.781ZM585.781 416V408H609.781V416H585.781Z"
                    fill="#524D4E"
                  />
                </g>
              </g>
              <g id="Group_25">
                <g id="Group_26">
                  <path
                    id="Vector_33"
                    d="M962 376H922V424H962V376Z"
                    fill="#4BB9EC"
                  />
                </g>
                <g id="Group_27">
                  <path
                    id="Vector_34"
                    d="M962 368H922C917.578 368 914 371.578 914 376V424C914 428.422 917.578 432 922 432H962C966.422 432 970 428.422 970 424V376C970 371.578 966.422 368 962 368ZM954 384V392H930V384H954ZM930 416V408H954V416H930Z"
                    fill="#524D4E"
                  />
                </g>
              </g>
              <g id="Group_28">
                <g id="Group_29">
                  <path
                    id="Vector_35"
                    d="M889.782 376H849.782V424H889.782V376Z"
                    fill="#4BB9EC"
                  />
                </g>
                <g id="Group_30">
                  <path
                    id="Vector_36"
                    d="M889.781 368H849.781C845.359 368 841.781 371.578 841.781 376V424C841.781 428.422 845.359 432 849.781 432H889.781C894.203 432 897.781 428.422 897.781 424V376C897.781 371.578 894.203 368 889.781 368ZM881.781 384V392H857.781V384H881.781ZM857.781 416V408H881.781V416H857.781Z"
                    fill="#524D4E"
                  />
                </g>
              </g>
              <g id="Group_31">
                <g id="Group_32">
                  <path
                    id="Vector_37"
                    d="M961.563 300C961.563 288.954 952.609 280 941.563 280C930.517 280 921.563 288.954 921.563 300C921.563 301.37 921.704 302.707 921.966 304H921.563V336H961.563V304H961.16C961.422 302.707 961.563 301.37 961.563 300Z"
                    fill="#4BB9EC"
                  />
                </g>
                <g id="Group_33">
                  <path
                    id="Vector_38"
                    d="M941.781 272C926.343 272 913.781 284.562 913.781 300V336C913.781 340.422 917.359 344 921.781 344H961.781C966.203 344 969.781 340.422 969.781 336V300C969.781 284.562 957.219 272 941.781 272ZM941.781 288C948.398 288 953.781 293.383 953.781 300V304H929.781V300C929.781 293.383 935.164 288 941.781 288ZM929.781 328V320H953.781V328H929.781Z"
                    fill="#524D4E"
                  />
                </g>
              </g>
              <g id="Group_34">
                <g id="Group_35">
                  <path
                    id="Vector_39"
                    d="M617.563 300C617.563 288.954 608.609 280 597.563 280C586.517 280 577.563 288.954 577.563 300C577.563 301.37 577.704 302.707 577.966 304H577.563V336H617.563V304H617.16C617.422 302.707 617.563 301.37 617.563 300Z"
                    fill="#4BB9EC"
                  />
                </g>
                <g id="Group_36">
                  <path
                    id="Vector_40"
                    d="M597.781 272C582.343 272 569.781 284.562 569.781 300V336C569.781 340.422 573.359 344 577.781 344H617.781C622.203 344 625.781 340.422 625.781 336V300C625.781 284.562 613.219 272 597.781 272ZM597.781 288C604.398 288 609.781 293.383 609.781 300V304H585.781V300C585.781 293.383 591.164 288 597.781 288ZM585.781 328V320H609.781V328H585.781Z"
                    fill="#524D4E"
                  />
                </g>
              </g>
              <g id="Group_37">
                <g id="Group_38">
                  <path
                    id="Vector_41"
                    d="M689.344 300C689.344 288.954 680.39 280 669.344 280C658.298 280 649.344 288.954 649.344 300C649.344 301.37 649.485 302.707 649.747 304H649.344V336H689.344V304H688.941C689.203 302.707 689.344 301.37 689.344 300Z"
                    fill="#4BB9EC"
                  />
                </g>
                <g id="Group_39">
                  <path
                    id="Vector_42"
                    d="M669.563 272C654.125 272 641.563 284.562 641.563 300V336C641.563 340.422 645.141 344 649.563 344H689.563C693.985 344 697.563 340.422 697.563 336V300C697.563 284.562 685 272 669.563 272ZM669.563 288C676.18 288 681.563 293.383 681.563 300V304H657.563V300C657.563 293.383 662.945 288 669.563 288ZM657.563 328V320H681.563V328H657.563Z"
                    fill="#524D4E"
                  />
                </g>
              </g>
              <g id="clockHands">
                <rect
                  id="Rectangle 37"
                  x="765"
                  y="212"
                  width="10"
                  height="36"
                  fill="#524D4E"
                >
                  <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 770 248"
                    to="360 770 248"
                    dur="1.5s"
                    repeatCount="indefinite"
                  />
                </rect>
                <rect
                  id="Rectangle 38"
                  x="765"
                  y="223"
                  width="10"
                  height="25"
                  fill="#524D4E"
                >
                  <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 770 248"
                    to="360 770 248"
                    dur="8s"
                    repeatCount="indefinite"
                  />
                </rect>
                <circle
                  id="Ellipse 4"
                  r="5"
                  transform="matrix(-1 0 0 1 770 248)"
                  fill="#524D4E"
                />
              </g>
              <g id="clockOutline">
                <path
                  id="Vector_43"
                  d="M770 304C739.121 304 714 278.879 714 248C714 217.121 739.121 192 770 192C800.879 192 826 217.121 826 248C826 278.879 800.879 304 770 304ZM770 208C747.945 208 730 225.943 730 248C730 270.057 747.945 288 770 288C792.055 288 810 270.057 810 248C810 225.943 792.055 208 770 208Z"
                  fill="#524D4E"
                />
              </g>
              <g id="doorOutline">
                <path
                  id="Vector_44"
                  d="M802 328H738C724.766 328 714 338.766 714 352V464C714 468.422 717.578 472 722 472C726.422 472 730 468.422 730 464V376H761.781V464H777.781V376H810V464C810 468.422 813.578 472 818 472C822.422 472 826 468.422 826 464V352C826 338.766 815.234 328 802 328ZM810 360H730V352C730 347.586 733.586 344 738 344H802C806.414 344 810 347.586 810 352V360Z"
                  fill="#524D4E"
                />
              </g>
              <g id="schoolBase">
                <path
                  id="Vector_45"
                  d="M1018 472H522C517.578 472 514 468.422 514 464C514 459.578 517.578 456 522 456H1018C1022.42 456 1026 459.578 1026 464C1026 468.422 1022.42 472 1018 472Z"
                  fill="#524D4E"
                />
              </g>
            </g>
            <g id="kid4">
              <circle
                id="Ellipse 1"
                r="9.5"
                transform="matrix(-1 0 0 1 151.5 384.5)"
                fill="#DEC37E"
              />
              <rect
                id="Rectangle 2"
                width="7"
                height="19"
                rx="3.5"
                transform="matrix(-1 0 0 1 160 414)"
                fill="#2F50A5"
              />
              <rect
                id="Rectangle 8"
                width="7"
                height="3"
                rx="1.5"
                transform="matrix(-1 0 0 1 160 431)"
                fill="#070D1E"
              />
              <rect
                id="Rectangle 3"
                width="7"
                height="19"
                rx="3.5"
                transform="matrix(-1 0 0 1 150 414)"
                fill="#2F50A5"
              />
              <rect
                id="Rectangle 1"
                width="19"
                height="25"
                rx="9.5"
                transform="matrix(-1 0 0 1 161 394)"
                fill="#17B931"
              />
              <rect
                id="Rectangle 4"
                width="4"
                height="17"
                rx="2"
                transform="matrix(-1 0 0 1 163 396)"
                fill="#16C031"
              />
              <rect
                id="Rectangle 9"
                width="7"
                height="3"
                rx="1.5"
                transform="matrix(-1 0 0 1 150 431)"
                fill="#070D1E"
              />
              <rect
                id="Rectangle 5"
                width="4"
                height="4"
                rx="2"
                transform="matrix(-1 0 0 1 163 409)"
                fill="#DEC37E"
              />
              <rect
                id="Rectangle 6"
                width="4"
                height="17"
                rx="2"
                transform="matrix(-1 0 0 1 144 396)"
                fill="#16C031"
              />
              <rect
                id="Rectangle 7"
                width="4"
                height="4"
                rx="2"
                transform="matrix(-1 0 0 1 144 409)"
                fill="#DEC37E"
              />
            </g>
            <g id="kid3">
              <circle
                id="Ellipse 3"
                r="9.5"
                transform="matrix(-1 0 0 1 151.5 384.5)"
                fill="#F2D790"
              />
              <rect
                id="Rectangle 19"
                width="7"
                height="19"
                rx="3.5"
                transform="matrix(-1 0 0 1 160 414)"
                fill="#2F50A5"
              />
              <rect
                id="Rectangle 20"
                width="7"
                height="3"
                rx="1.5"
                transform="matrix(-1 0 0 1 160 431)"
                fill="#070D1E"
              />
              <rect
                id="Rectangle 21"
                width="7"
                height="19"
                rx="3.5"
                transform="matrix(-1 0 0 1 150 414)"
                fill="#2F50A5"
              />
              <rect
                id="Rectangle 22"
                width="19"
                height="25"
                rx="9.5"
                transform="matrix(-1 0 0 1 161 394)"
                fill="#D0D509"
              />
              <rect
                id="Rectangle 23"
                width="4"
                height="17"
                rx="2"
                transform="matrix(-1 0 0 1 163 396)"
                fill="#C6CA0D"
              />
              <rect
                id="Rectangle 24"
                width="7"
                height="3"
                rx="1.5"
                transform="matrix(-1 0 0 1 150 431)"
                fill="#070D1E"
              />
              <rect
                id="Rectangle 25"
                width="4"
                height="4"
                rx="2"
                transform="matrix(-1 0 0 1 163 409)"
                fill="#F2D790"
              />
              <rect
                id="Rectangle 26"
                width="4"
                height="17"
                rx="2"
                transform="matrix(-1 0 0 1 144 396)"
                fill="#C6CA0D"
              />
              <rect
                id="Rectangle 27"
                width="4"
                height="4"
                rx="2"
                transform="matrix(-1 0 0 1 144 409)"
                fill="#F2D790"
              />
            </g>
            <g id="kid2">
              <circle
                id="Ellipse 2"
                r="9.5"
                transform="matrix(-1 0 0 1 151.5 384.5)"
                fill="#BCA363"
              />
              <rect
                id="Rectangle 10"
                width="7"
                height="19"
                rx="3.5"
                transform="matrix(-1 0 0 1 160 414)"
                fill="#2F50A5"
              />
              <rect
                id="Rectangle 11"
                width="7"
                height="3"
                rx="1.5"
                transform="matrix(-1 0 0 1 160 431)"
                fill="#070D1E"
              />
              <rect
                id="Rectangle 12"
                width="7"
                height="19"
                rx="3.5"
                transform="matrix(-1 0 0 1 150 414)"
                fill="#2F50A5"
              />
              <rect
                id="Rectangle 13"
                width="19"
                height="25"
                rx="9.5"
                transform="matrix(-1 0 0 1 161 394)"
                fill="#8517B9"
              />
              <rect
                id="Rectangle 14"
                width="4"
                height="17"
                rx="2"
                transform="matrix(-1 0 0 1 163 396)"
                fill="#981BD2"
              />
              <rect
                id="Rectangle 15"
                width="7"
                height="3"
                rx="1.5"
                transform="matrix(-1 0 0 1 150 431)"
                fill="#070D1E"
              />
              <rect
                id="Rectangle 16"
                width="4"
                height="4"
                rx="2"
                transform="matrix(-1 0 0 1 163 409)"
                fill="#BCA363"
              />
              <rect
                id="Rectangle 17"
                width="4"
                height="17"
                rx="2"
                transform="matrix(-1 0 0 1 144 396)"
                fill="#981BD2"
              />
              <rect
                id="Rectangle 18"
                width="4"
                height="4"
                rx="2"
                transform="matrix(-1 0 0 1 144 409)"
                fill="#BCA363"
              />
            </g>
            <g id="kid1">
              <circle
                id="Ellipse 4_2"
                r="9.5"
                transform="matrix(-1 0 0 1 151.5 384.5)"
                fill="#856B27"
              />
              <rect
                id="Rectangle 28_2"
                width="7"
                height="19"
                rx="3.5"
                transform="matrix(-1 0 0 1 160 414)"
                fill="#2F50A5"
              />
              <rect
                id="Rectangle 29_2"
                width="7"
                height="3"
                rx="1.5"
                transform="matrix(-1 0 0 1 160 431)"
                fill="#070D1E"
              />
              <rect
                id="Rectangle 30_2"
                width="7"
                height="19"
                rx="3.5"
                transform="matrix(-1 0 0 1 150 414)"
                fill="#2F50A5"
              />
              <rect
                id="Rectangle 31_2"
                width="19"
                height="25"
                rx="9.5"
                transform="matrix(-1 0 0 1 161 394)"
                fill="#B91734"
              />
              <rect
                id="Rectangle 32_2"
                width="4"
                height="17"
                rx="2"
                transform="matrix(-1 0 0 1 163 396)"
                fill="#CF203F"
              />
              <rect
                id="Rectangle 33_2"
                width="7"
                height="3"
                rx="1.5"
                transform="matrix(-1 0 0 1 150 431)"
                fill="#070D1E"
              />
              <rect
                id="Rectangle 34_2"
                width="4"
                height="4"
                rx="2"
                transform="matrix(-1 0 0 1 163 409)"
                fill="#856B27"
              />
              <rect
                id="Rectangle 35_2"
                width="4"
                height="17"
                rx="2"
                transform="matrix(-1 0 0 1 144 396)"
                fill="#CF203F"
              />
              <rect
                id="Rectangle 36_2"
                width="4"
                height="4"
                rx="2"
                transform="matrix(-1 0 0 1 144 409)"
                fill="#856B27"
              />
            </g>

            <g id="doorCover">
              <rect
                id="Rectangle 39"
                x="761.78"
                y="376"
                width="17"
                height="80"
                fill="#524D4E"
              />
              <rect
                id="Rectangle 40"
                x="777.78"
                y="376"
                width="32"
                height="80"
                fill="#996459"
              />
            </g>
            <g id="busCover">
              <path
                id="Subtract"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M163 434H145.029C140.824 434 137.382 430.77 137 427.216V325.784C137 321.907 140.824 319 145.029 319H163V434Z"
                fill="#F47E60"
              />
            </g>
          </g>
        </svg>
      </div>
    </React.Fragment>
  );
};

export default StudentBulkImportLoading;



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/LoadingComponents/StudentBulkImportLoading.js